import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/perfilacesso/';

class PerfilAcessoService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllByPerfil(idPerfil) {
        return axios.get(API_URL + 'all?idPerfil='+idPerfil, {headers: this.headers});
    }
    
    save(perfisAcesso) {
        return axios.post(API_URL, JSON.stringify(perfisAcesso),
        {headers: this.headers});
    }


}

export default new PerfilAcessoService();